import React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import Drawer from "@mui/material/Drawer";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
// import CloseIcon from "@mui/icons-material/Close";
// import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import SoftSelect from "components/SoftSelect";
import { Box, Card } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function ExpenseDrawer({ open, onClose, selectedType, handleClose }) {
      const [reason, setReason] = useState("");
    
      const handleSubmit = (e) => {
    e.preventDefault();
    console.log({
      destination,
      startDate: selectedStartDate.format("YYYY-MM-DD"),
    //   endDate: selectedEndDate.format("YYYY-MM-DD"),
      amount,
      notes,
    });
  };

   const [selectedStartDate, setSelectedStartDate] = useState(dayjs());
   const [anchorStart, setAnchorStart] = useState(null);
  const handleOpenCalendar = (event, type) => {
    if (type === "start") setAnchorStart(event.currentTarget);
    else setAnchorEnd(event.currentTarget);
  };

  const handleCloseCalendar = (type) => {
    if (type === "start") setAnchorStart(null);
    else setAnchorEnd(null);
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{
            sx: { width: 850, maxWidth: 1200 }, 
          }}>
      <SoftBox sx={{ width: 850, p: 3 }}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        </SoftBox>

        {selectedType === "travel" && (
        <Card>
      <SoftBox p={3}>
        {/* Header */}
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <SoftTypography variant="h5">Travel Expense</SoftTypography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </SoftBox>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Destination</SoftTypography>
            <SoftInput type="text" placeholder="Enter Destination" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Amount</SoftTypography>
            <SoftInput type="text" placeholder="Enter Amount" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Date</SoftTypography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              border={1}
              borderRadius={2}
              borderColor="#ced4da"
              px={2}
              minHeight="42px"
            >
              <Typography
                fontWeight="medium"
                fontSize={16}
                color={selectedStartDate ? "text.secondary" : "text.primary"}
              >
                {selectedStartDate ? selectedStartDate.format("DD-MMM-YYYY") : "Select date"}
              </Typography>

              <IconButton onClick={(e) => handleOpenCalendar(e, "start")}>
                <CalendarTodayIcon />
              </IconButton>

              <Popover
                open={Boolean(anchorStart)}
                anchorEl={anchorStart}
                onClose={() => handleCloseCalendar("start")}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{
                  sx: { backgroundColor: "#fff", borderRadius: 2, boxShadow: 3, p: 1 },
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={selectedStartDate}
                    minDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectedStartDate(newValue);
                      handleCloseCalendar("start");
                      if (onDateChange) onDateChange(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Popover>
            </Box>
          </SoftBox>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Upload Bill </SoftTypography>
            <Grid item xs={12}>
              <SoftInput type="file" />
            </Grid>
          </SoftBox>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Notes</SoftTypography>
            <TextField
              fullWidth
              multiline
              rows={3}
              placeholder="Notes"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </SoftBox>
          <SoftBox display="flex" gap={2} mt={3}>
            <SoftButton type="submit" variant="gradient" color="info">Submit Travel Expense</SoftButton>
          </SoftBox>
        </form>
      </SoftBox>
    </Card>
        )}

        {selectedType === "food" && (
        <Card>
      <SoftBox p={3}>
        {/* Header */}
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <SoftTypography variant="h5">Food Expense</SoftTypography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </SoftBox>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Resturant</SoftTypography>
            <SoftInput type="text" placeholder="Enter Destination" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Amount</SoftTypography>
            <SoftInput type="text" placeholder="Enter Amount" />
          </SoftBox>

          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Date</SoftTypography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              border={1}
              borderRadius={2}
              borderColor="#ced4da"
              px={2}
              minHeight="42px"
            >
              <Typography
                fontWeight="medium"
                fontSize={16}
                color={selectedStartDate ? "text.secondary" : "text.primary"}
              >
                {selectedStartDate ? selectedStartDate.format("DD-MMM-YYYY") : "Select date"}
              </Typography>

              <IconButton onClick={(e) => handleOpenCalendar(e, "start")}>
                <CalendarTodayIcon />
              </IconButton>

              <Popover
                open={Boolean(anchorStart)}
                anchorEl={anchorStart}
                onClose={() => handleCloseCalendar("start")}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{
                  sx: { backgroundColor: "#fff", borderRadius: 2, boxShadow: 3, p: 1 },
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={selectedStartDate}
                    minDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectedStartDate(newValue);
                      handleCloseCalendar("start");
                      if (onDateChange) onDateChange(newValue);
                    }}
                  />
                </LocalizationProvider>
              </Popover>
            </Box>
          </SoftBox>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Upload Bill </SoftTypography>
            <Grid item xs={12}>
              <SoftInput type="file" />
            </Grid>
          </SoftBox>
          <SoftBox mt={2}>
            <SoftTypography variant="h6" color="#344767">Notes</SoftTypography>
            <TextField
              fullWidth
              multiline
              rows={3}
              placeholder="Notes"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </SoftBox>
          <SoftBox display="flex" gap={2} mt={3}>
            <SoftButton type="submit" variant="gradient" color="info">Submit Food Expense</SoftButton>
          </SoftBox>
        </form>
      </SoftBox>
    </Card>
        )}
      </SoftBox>
    </Drawer>
  );
}

ExpenseDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedType: PropTypes.string,
   handleClose: PropTypes.func,
};

export default ExpenseDrawer;
